import React, {Component} from 'react';
import './DrugTypeSummary.css';
import Card from "../../components/card/Card";
import CardHeader from "../../components/cardHeader/CardHeader";
import Label from "../../components/label/Label";
import drugUtils from "../../utils/drugUtils";
import Input from "../../inputs/input/Input";
import models from "../../model/models";
import toasts from "../../utils/toasts";

export default class DrugTypeSummary extends Component {

	_deployedCount = (type) => {
		return drugUtils.deployedCount(this.props.drugs, type);
	};

	_centralCount = (type) => {
		return drugUtils.centralCount(this.props.drugs, type);
	};

	_totalCount = (type) => {
		return drugUtils.totalCount(this.props.drugs, type);
	};

	_updateParValue = (value, drug_type) => {
		if(value != parseInt(value)){
			return toasts.show('Enter a number');
		}
		let user_group = this.props.user_group || {};
		user_group.par_values[drug_type] = value;
		models.user_group.save(user_group);
	};

	_updateUnitParValue = (value, drug_type) => {
		if(value != parseInt(value)){
			return toasts.show('Enter a number');
		}
		const {user_group} = this.props || {};
		const {unit_par_values} = user_group || {};
		user_group.unit_par_values = Object.assign({}, unit_par_values || {}, {
			[drug_type]: value,
		});
		models.user_group.save(user_group);
	}

	_renderTypes = () => {
		const {
			types: drug_types,
			user_group: {par_values = {}, unit_par_values = {}} = {par_values: {}, unit_par_values: {}}
		} = this.props || {user_group: {par_values: {}, unit_par_values: {}}};
		let display = [];
		for (let i in drug_types) {
			let type = drug_types[i].id;
			const deployed = this._deployedCount(type);
			const central = this._centralCount(type);
			const total = this._totalCount(type);
			if(this.props.hideEmpty && !total){
				continue;
			}
			display.push(
				<div key={i} className="row">
					<Label gray-dark>{drug_types[i].name}</Label>
					<Label gray-dark>{deployed}</Label>
					<Label gray-dark>{central}</Label>
					<Label gray-dark>{total}</Label>
					{this.props.includePar && <><ParValue
						value={par_values[type]}
						onChange={(value) => {
							this._updateParValue(value, type);
						}}
					/>
					<ParValue
						value={unit_par_values && unit_par_values[type]}
						onChange={(value) => {
							this._updateUnitParValue(value, type);
						}}
					/></>}
				</div>
			);
		}
		return display;
	};
	render() {
		return (
			<Card className="g-drug-type-summary">
				<CardHeader className="title">Summary</CardHeader>
				<div className="top-row">
					<Label black>Type</Label>
					<Label black>Deployed</Label>
					<Label black>Supply</Label>
					<Label black>Total</Label>
					{this.props.includePar && <><Label black className={'par-header'}>Par Value</Label>
					<Label black className={'par-header'}>Unit Par Value</Label>
					</>}
				</div>
				<div className="list">{this._renderTypes()}</div>
			</Card>
		)
	}
}

class ParValue extends Component {
	constructor(props) {
		super(props);
		this.state = {
			mode: 'view'
		};
	}

	_editMode = () => {
		this.setState({ mode: 'edit' });
	};

	_viewMode = () => {
		this.setState({ mode: 'view' });
	};

	onChange = () => {
		let value = this.input.getValue();
		parseInt(value);
		this.props.onChange(value);
		this._viewMode();
	};

	render() {
		if (this.state.mode === 'view') {
			return (
				<div className="par-value view">
					<Label gray-dark>{this.props.value} Vials</Label>
					<Label bold blue onClick={this._editMode} className="edit">
						Edit
					</Label>
				</div>
			);
		} else {
			return (
				<div className="par-value edit">
					<Input gray-dark ref={(ref) => (this.input = ref)} value={this.props.value} />
					<Label bold blue onClick={this.onChange}>
						Save
					</Label>
					<Label blue onClick={this._viewMode}>
						Cancel
					</Label>
				</div>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/cards/drugTypeSummary/DrugTypeSummary.jsx